import { useStore } from '../store/hooks'

export const useOver18 = () => {
  return useStore(s => s.over18.isOver18)
}
